import React, { Component } from 'react';
import styled, { css } from 'styled-components';
import Swiper from 'swiper/js/swiper.js';
import debounce from 'lodash.debounce';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom'

import WP from 'WP';
import Container from 'partials/Container';
import GridElement from 'partials/GridElement';
import Image from 'partials/Image';
import Html from 'partials/Html';
import IconSelector from 'partials/IconSelector';
import ImageGallery from 'partials/ImageGallery';

import {
    setOverlayValue,
} from 'store';

import Media, { ScreenWidth } from 'css/Media';

export class RoomTypeCarousel extends Component {

    constructor(props) {
        super(props);
        this.state = {
            active: 0
        };
        this.swiperRef = React.createRef();
    }

    componentWillMount() {
        this.checkScreenSize();
    }

    componentDidMount() {
        window.addEventListener('resize', debounce(() => this.checkScreenSize()),500);
        this.initSwiper();
    }

    componentDidUpdate(prevProps) {
        if(prevProps.hotel !== this.props.hotel) {
            this.initSwiper()
        }
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.checkScreenSize);
    }

    initSwiper = () => {
        this.swiper = new Swiper(this.swiperRef.current, {
            initialSlide: 0,
            slidesPerView: 'auto',
            allowTouchMove: this.state.isMobile ? true : false,
            loop: true,
            loopedSlides: this.props.roomTypes.length,
            centeredSlides: false,
        })
        this.swiper.on('slideChange', () => {
            this.setState({active: this.swiper.realIndex});
        })
    };

    checkScreenSize() {
        let isDesktop = false;
        let isMobile = false;

        if(ScreenWidth.lessThan('s')) {
            isMobile = true;
        }
        if(ScreenWidth.greaterThan('m')) {
            isDesktop = true;
        }
        this.setState({
            isDesktop: isDesktop,
            isMobile: isMobile
        });
    }

    handlePagination(index) {
        this.setState({active: index});
        this.swiper.slideTo(index + this.props.roomTypes.length);
    }

    handleGalleryClick = (images) => {
        this.props.setOverlayValue({
            visible: true, 
            component: <ImageGallery images={images} startAt={0} />})
    }

    render() {
        const { active, isMobile } = this.state;
        const { roomTypes } = this.props;
        
        return(
            <Wrapper>
                <Container grid>
                    <GridElement
                        colStart={{default: 1, s: 3}}
                        colEnd={{default: 8, s: 13}}
                        rowStart={1}
                        colSpan
                    >
                        <h4>{WP.trans.theRooms}</h4>
                    </GridElement>
                    { !isMobile &&
                        <NavGridElement
                            colStart={{default: 1, s: 3}}
                            colEnd={{default: 8, s: 13}}
                            rowStart={2}
                            colSpan
                        >
                        { roomTypes.map((roomType, i) => {
                            return (
                                <StyledLi key={roomType.id} isActive={active === i} onClick={() => this.handlePagination(i)}>
                                    {roomType.room_name}
                                </StyledLi>
                            )
                        })}
                        </NavGridElement>
                    }
                </Container>
                <Container bleedRight>
                    <div className="swiper-container" ref={this.swiperRef}>
                        <div className="swiper-wrapper">
                            { roomTypes.map(roomType => {
                                return (
                                    <div className="swiper-slide" key={roomType.id}>
                                        <ImageOverlay disabled={false} onClick={false ? null : () => this.handleGalleryClick(roomType.image_gallery)}>
                                            <StyledImage  image={roomType.featured_image} background ratio={isMobile ? '5:4.4': '2:1'}>
                                                <GalleryPopUp>
                                                    <IconSelector icon="gallery" negative />
                                                    <span>{`+ ${roomType.image_gallery.length}`}</span>
                                                </GalleryPopUp>
                                            </StyledImage >
                                        </ImageOverlay>
                                        <StyledContent>
                                            <h3>{roomType.room_name}</h3>
                                            { <Html content>{roomType.rich_text[0].text_field}</Html>}
                                        </StyledContent>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </Container>
            </Wrapper>
        )
    }
}

const mapStateToProps = state => ({
    overlayValue: state.overlayValue,
})

const actions = {
    setOverlayValue
}

export default connect(mapStateToProps, actions)(withRouter(RoomTypeCarousel));


const Wrapper = styled.section`
    user-select: none;
    padding-bottom: ${props => props.theme.spacing.elementXL};

    .swiper-container {
        display: flex;
        overflow-x: hidden;
        .swiper-wrapper {
            display: flex;
            align-items: center;
            .swiper-slide {
                display: flex;
                flex-direction: column;
                width: 73.2309231vw;
                color : black;
                z-index: 1000;
                padding-right: 7.077vw;

                a {
                    color: ${props => props.theme.colors.text};
                }

                ${Media.greaterThan('s')`
                    flex-direction: row;
                    width: calc(100vw - (167px + 8.611vw));
                    padding-right: 0;
                `}

                ${Media.greaterThan('xl')`
                    max-width: 1629.66px;
                `}
            }
        }
        ${Media.greaterThan('s')`
            margin-left: 8.611%;
        `}

        ${Media.greaterThan('xl')`
            margin-left: calc(18 * 8.611px);
        `}
    }

    .container {
        h4 {
            margin-bottom: ${props => props.theme.spacing.contentXL};

            ${Media.greaterThan('s')`
                margin-bottom: ${props => props.theme.spacing.elementM};
            `}
        }
    }

    ${Media.greaterThan('s')`
        padding-bottom: ${props => props.theme.spacing.blockXL};
    `}
`

const NavGridElement = styled(GridElement)`
    display: flex;
    margin-bottom: ${props => props.theme.spacing.elementXS};
`


const StyledLi = styled.li`
    ${props => props.theme.fonts.p}
    cursor: pointer;
    list-style-type: none;
    color: ${props => props.isActive ? props.theme.colors.text : props.theme.colors.link};
    margin-right: ${props => props.theme.spacing.contentXL};
    white-space: nowrap;

    &:last-of-type {
        margin-right: 0;
    }
`

const MobileCard = styled.div`
    width: 100%;
`

const StyledImage = styled(Image)`
    width: 100%;
    height: 100%;
    padding-top: 100%;

    ${Media.greaterThan('s')`
        width: 40.4166666667vw;
    `}
`

const StyledContent = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;

    p {
        font-size: 16px;
        line-height: 25px;
        padding: ${props => props.theme.spacing.contentL} 0;

        &:last-of-type {
            padding: 0 0 ${props => props.theme.spacing.elementS};
        }
    }

    ${Media.greaterThan('s')`
        width: 50%;
        padding: 0 ${props => props.theme.spacing.contentXL};

        h3 {
            padding-bottom: ${props => props.theme.spacing.contentM};
        }
    `}
    
    ${Media.greaterThan('m')`
        padding: 0 130px;
    `}

    ${Media.greaterThan('l')`
        padding: 0 ${props => props.theme.spacing.blockL};
    `}

    ${Media.greaterThan('xl')`
        padding: 0 190px;
    `}

    ${Media.lessThan('m')`
        p {
            font-size: 14px;
            line-height: 20px;
        }
    `}

    ${Media.lessThan('s')`
        h3 {
            width: 100%;
            padding: 11px 0 0;
        }

        p {
            &:last-of-type {
                padding: 0 0 ${props => props.theme.spacing.contentM};
            }
        }
    `}
`

const ImageOverlay = styled.div`
    width: 100%;
    height: 100%;

    ${Media.greaterThan('s')`
        width: 40.4166666667vw;
    `}

    &::after {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        content: '';
        background-color: transparent;
        transition: all .2s ease-in;
    }
    ${props => !props.disabled && css`
        cursor: pointer;
        &:hover {
            &::after {
                background-color: rgba(0, 0, 0, .2);
            }
        }
    `}
`

const GalleryPopUp = styled.div`
    position: absolute;
    bottom: 0;
    left: 0;
    padding: ${props => props.theme.spacing.contentL} 25px;
    z-index: 1;
    display: flex;
    color: ${props => props.theme.colors.negative};

    span {
        margin-right: ${props => props.theme.spacing.contentXS};
        color: white !important;
    }

    p {
        text-decoration: underline;
    }

    ${Media.greaterThan('l')`
        padding: ${props => props.theme.spacing.contentL} ${props => props.theme.spacing.contentXL};
    `}
`